<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="分类名称" prop="title">
                        <Input v-model="info.title" :maxlength="20" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="排序" prop="sortNum">
                        <input-number v-model="info.sortNum" placeholder :allowDecimal="false"></input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="启用/禁用" prop="enabled">
                        <Input v-model="catelogEnable" placeholder disabled></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="图标" prop="attachments">
                        <preview-upload
                            v-model="info.attachments"
                            multiple
                            :format="imgSuffix"
                            :maxNumber="1"
                        ></preview-upload>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="备注" prop="remark">
                        <Input
                            v-model="info.remark"
                            type="textarea"
                            :rows="3"
                            placeholder="0/1000"
                            :maxlength="1000"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>

import { catalogAdd, catalogUpdate, catalogView } from "@/api/merch";
import config from "@/config";
import PreviewUpload from "_c/preview-upload";

export default {
    name: "p-catalog-form",

    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },

    components: { PreviewUpload },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            info: {
                id: this.id,
                title: "", // 分类名称
                sortNum: "", // 排序
                enabled: 1, // 启用/禁用
                attachments: "", // 图标
                remark: "", // 备注
                ver: "" // 版本号
            },

            imgSuffix: config.upload.imgSuffix,

            catalogStatusList: this.$enum.get("isEnable").toList()
        };
    },

    computed: {
        ruleValidate() {
            return {
                title: [{ required: true, message: "分类名称必填" }],
                sortNum: [{ required: true, message: "排序必填" }],
                attachments: [{ required: true, message: "图标必填" }]
            };
        },
        catelogEnable(){
            return this.catalogStatusList.find(item => item.id === this.info.enabled).text
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return catalogView(this.id);
            } else {
                return Promise.resolve();
            }
        }
    },

    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        var btns = [{ type: "default", text: "取消", name: "cancel" }];

        if (this.$can("update")) {
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定"
            });
        }
        this.$modal.updateBtns(btns);

        // 预加载
        this.$modal.beforeEnter(next => {
            
            Promise.all([this.fetch()])
                .then(args => {
                    var [view] = args;

                    if (view) {
                        var viewData = view.data.entity;

                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        );
                    }
                })
                .finally(() => {
                    next();
                });
        });

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info);

                    if (this.id) {
                        return catalogUpdate(formData);
                    } else {
                        return catalogAdd(formData);
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t("tips.update.success"));
                    } else {
                        this.$Message.success(this.$t("tips.add.success"));
                    }
                })
                .catch(err => {
                    options.closeModal = false;
                })
                .finally(() => {
                    next();
                });
        });
    }
};
</script>
<style lang="less" scoped></style>
